export default "__VITE_ASSET__BzNuQGfV__"